/**
 * Component Registry for Atrium Court
 *
 * Inherits from @vibesites-weidner-apartment-homes-rise/theme-rise.
 * No property-specific component overrides at this time — the
 * header nav / logo and HeroSolidBG CTA luminance behavior is now
 * handled correctly by the inherited parent components, so this
 * site's registry is a pass-through.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-weidner-apartment-homes-rise/theme-rise/registry';

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
};

export default registry;
